import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { getTimes } from '../models/times';

class closingTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      time: null
    };
  }

  componentDidMount() {
    this.intervalID = setInterval(
      () => this.refresh(),
      360000
    );
    this.retrieveClosingTime();
  }

  retrieveClosingTime() {
    localStorage.removeItem('closingTime');
    let localStorageZmanim = JSON.parse(localStorage.getItem('zmanim'));
    let LastEntryStartOfDay = localStorageZmanim && localStorageZmanim.data ? (moment(localStorageZmanim.data.lastEntryTime).hour()<5?moment(localStorageZmanim.data.lastEntryTime).subtract(1,'d').startOf('day'):moment(localStorageZmanim.data.lastEntryTime).startOf('day')):null;
    let savedDate = localStorageZmanim && localStorageZmanim.savedTime ? moment(localStorageZmanim.savedTime) : null;
    let today = moment().startOf('day');

    if ( localStorageZmanim && moment(LastEntryStartOfDay).isSame(today) && !moment().isAfter(savedDate,'hour') ) {
      this.setState({
        isLoaded: true,
        lastBath: localStorageZmanim.data.lastBath,
        lastEntry: localStorageZmanim.data.lastEntryTime
      })
      return false;
    }
    getTimes()
      .then(
        result => {
          localStorage.setItem('zmanim', JSON.stringify({savedTime: moment().format(), data: result }));
          this.setState({
            isLoaded: true,
            lastBath: result.lastBath,
            lastEntry: result.lastEntryTime
    
          })
        }
      );
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  refresh() {
    this.retrieveClosingTime();
  }

  render() {
    const { t } = this.props;
    const { isLoaded, lastBath, lastEntry} = this.state;
    return isLoaded ? (
      <>
      <div className="closing-time">
        <div className="title">{t("Last Bath")}</div>
        <Moment format={t("h:mm A")} element="span">{lastBath}</Moment>
      </div>
      <div className="closing-time">
        <div className="title">{t("Last Shower")}</div>
        <Moment format={t("h:mm A")} element="span">{lastEntry}</Moment>
      </div>
      </>
    ) : null;
  }
}

export default withTranslation()(closingTime);